import { BoxDiv } from './style'

const BoxShadow = ({
  width,
  className,
  children,
  padding,
  radius,
  margin,
  flex,
  overflow,
  minWidth,
}) => {
  return (
    <BoxDiv
      className={className}
      width={width}
      radius={radius}
      minWidth={minWidth}
      margin={margin}
      flex={flex}
      overflow={overflow}
      padding={padding}
    >
      {children}
    </BoxDiv>
  )
}
export default BoxShadow
